// domain/calculations/orderTotals.ts

import type { CartItem } from "../../model/product.cart.model";

export type OrderTotals = {
  totalQuantity: number; // litros
  subtotal: number; // soma dos subtotais
  totalPrice: number; // soma dos totais (com frete/imposto)
  hasValidItems: boolean; // existe item com quantity > 0
};

export function calculateOrderTotals(cart: CartItem[]): OrderTotals {
  let totalQuantity = 0;
  let subtotal = 0;
  let totalPrice = 0;
  let hasValidItems = false;

  for (const item of cart) {
    if (item.quantity > 0) {
      hasValidItems = true;

      // Itens com subtotal === 0 (ex: preço ainda não retornado pelo backend)
      // ficam fora de todos os somatórios para manter consistência entre
      // totalQuantity, subtotal e totalPrice exibidos no resumo do pedido.
      if (item.subtotal > 0) {
        totalQuantity += item.quantity;
        subtotal += item.subtotal;
        totalPrice += item.total;
      }
    }
  }

  return {
    totalQuantity,
    subtotal,
    totalPrice,
    hasValidItems,
  };
}
